import { CaretRight, Receipt } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

export function QuoteCard({ cart, onClick }) {
  const { t } = useTranslation();
  return (
    <button
      onClick={onClick}
      data-testid={`mobile-quote-card-${cart.id}`}
      className="press-scale w-full text-left bg-white flex items-center gap-3 px-4 py-3 border-b border-[#F1F0EE] last:border-b-0"
    >
      <div className="w-10 h-10 rounded-[10px] bg-[#1E3A8A]/8 flex items-center justify-center flex-shrink-0">
        <Receipt size={18} weight="duotone" className="text-[#1E3A8A]" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-base font-medium text-[#1C1917] truncate leading-tight">{cart.name}</p>
        <p className="text-xs text-[#78716C] mt-0.5 truncate">
          {cart.customer_name || t("mobile.no_customer")} &middot; {t("mobile.items", { count: cart.item_count })}
        </p>
      </div>
      <CaretRight size={16} className="text-[#A8A29E] flex-shrink-0" />
    </button>
  );
}
